import { useEffect } from 'react';

import { TaskLike } from '../../MemberOperator.interfaces';

import useEventTracking from 'modules/common/components/AnalyticsTracking/useEventTracking';

export default function useMemberOperatorSegment(task: TaskLike | undefined, trackViewOnMount = true) {
    const { sendTrackingEvent } = useEventTracking();

    useEffect(() => {
        if (task && trackViewOnMount) {
            sendTrackingEvent('MemberOperator Task Viewed', {
                category: 'member_operator_task_viewed',
                task_id: task.id,
                task_type: task.task_type,
                task_status: task.status,
                task_template_name: task.task_template.name,
            });
        }
    }, [task?.id, task?.status, trackViewOnMount]);
}
